/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_No_Tournaments_HintInputs */



/**
* | output |
* | --- |
* | "Link your events with \"Add event\" above — or from each tournament's Set up tab." |
*
* @param {League_No_Tournaments_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_no_tournaments_hint = /** @type {((inputs?: League_No_Tournaments_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_No_Tournaments_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liez vos événements avec « Ajouter un événement » ci-dessus — ou depuis l'onglet Préparation de chaque tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincule sus eventos con «Añadir evento» arriba — o desde la pestaña Preparación de cada torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincule seus eventos com “Adicionar evento” acima — ou pela aba Preparação de cada torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega i tuoi eventi con «Aggiungi evento» qui sopra — oppure dalla scheda Preparazione di ogni torneo.")
	return /** @type {LocalizedString} */ ("Link your events with \"Add event\" above — or from each tournament's Set up tab.")
});